import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, FooterButton } from 'Core/components';
import CustomPropTypes from 'Core/prop-types';
import { addWorkTicket, editWorkTicket } from './store/slice';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import WorkTicketAddEditForm from './work-ticket-add-edit-form';
import { useDocumentUpload } from '../../core/hooks';

const ignoreKeys = [

];

const WorkTicketAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const [formData, setFormData] = useState(modalData || null);
  const [tempFiles, setTempFile] = useState([]);
  const { uploadDocuments, loading } = useDocumentUpload();

  const dispatch = useDispatch();
  const isEditMode = Boolean(formData?.workorderid);

  const onFileUpload = (documentName, file) => {
    if (file) {
      setTempFile(prevFiles => {
        const updatedFiles = prevFiles.map(f =>
          f.documentName === documentName ? { ...f, file } : f,
        );

        // If documentName exists, update it; otherwise, add new file
        const isExisting = prevFiles.some(f => f.documentName === documentName);

        return isExisting ? updatedFiles : [...prevFiles, { file, documentName }];
      });
    }
  };

  const onChangesForm = data => {
    setFormData(data);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <WorkTicketAddEditForm
        data={formData}
        onChanges={onChangesForm}
        onFileUpload={onFileUpload}
        isEditMode={isEditMode}
      />
    );
  };

  const valid = () => {
    
//  if (
//       !formData ||
//       Object.keys(formData).some(key => {
//         return !ignoreKeys.includes(key) && !formData[key];
//       })
//     ) {
//       dispatch(
//         showToast({
//           message: 'Please fill all required fields',
//           type: 'danger',
//         }),
//       );
//       return false;
//     }
    return true;
  };


  const footer = () => {
    const onSave = () => {

      const payload = { ...formData };
      Object.keys(payload).forEach(key => {
        if (payload[key] === null) {
          payload[key] = '';
        }
      });
  
      if (valid()) {
      
        if (isEditMode) {
          dispatch(editWorkTicket(payload));
        } else {
          dispatch(addWorkTicket(payload));
        }
      }
    };

    return (
      <div className="row">
        <div className="col-lg-4"></div>
        <div className=" d-flex col-lg-6 col-md-6 col-sm-12">
          <FooterButton
            cancelText="Cancel"
            saveText="Save"
            printText="Print"
            onSave={onSave}
            onCancel={handleClose}
          />
          <button type="button" className="btn btn-primary me-2" data-bs-dismiss="modal">
            Print
          </button>
        </div>
      </div>
    );
  };

  return (
    <Modal
      id="work-ticket-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Edit WorkTicket' : 'Add WorkTicket'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

WorkTicketAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.WorkTicket),
  onCloseModal: PropTypes.func,
};

export default AppModal(WorkTicketAddEdit);
